import React, { useState } from 'react';
import { Card, Button, Breadcrumb, Descriptions, Space, Table, Tag, Row, Col, Typography, Modal, List, Input, message, Switch, Checkbox, Select, Radio, Alert, Form, Tabs, InputNumber, Drawer, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
    ArrowLeftOutlined, 
    EditOutlined, 
    AppstoreOutlined,
    SettingOutlined,
    InfoCircleOutlined,
    ReloadOutlined,
    QuestionCircleOutlined,
    VideoCameraOutlined,
    AudioOutlined,
    EyeOutlined,
    BellOutlined,
    DownOutlined,
    CameraOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const ProductManage = () => {
    const navigate = useNavigate();
    const [auditForm] = Form.useForm();
    const location = useLocation();

    const product = location.state || {
        productName: '未知产品',
        productId: 'P000000000',
        category: '未分类',
        status: '待审核',
        enterpriseName: '瀚晖通讯',
        price: '0.00'
    };

    // 状态样式配置
    const statusConfig = {
        '待审核': { color: 'orange', text: '待审核' },
        '审核通过': { color: 'green', text: '审核通过' },
        '审核不通过': { color: 'red', text: '审核不通过' },
        '开发中': { color: 'orange', text: '开发中' },
        '驳回开发中': { color: 'red', text: '驳回开发中' },
        '已发布': { color: 'green', text: '已发布' }
    };

    const [, setIsDetailModalOpen] = useState(false);
    const [, setModalConfig] = useState({ title: '', dataSource: [], type: 'list' });
    const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);
    const [auditResult, setAuditResult] = useState('pass');

    // 标准/自定义功能编辑弹窗状态
    const [isAbilityDrawerOpen, setIsAbilityDrawerOpen] = useState(false);
    const [activeAbilityTab, setActiveAbilityTab] = useState('standard');
    const [isAddAbilityModalOpen, setIsAddAbilityModalOpen] = useState(false);
    const [standardAbilities, setStandardAbilities] = useState([
        { key: '1', type: '属性', name: '关联子算法', id: 'SubAlgorithmType', dataType: 'String(字符串)', dataDef: '数据长度: 10241', desc: '', module: '-' }
    ]);

    // 管理员备注相关状态
    const [isEditingRemark, setIsEditingRemark] = useState(false);
    const [remark, setRemark] = useState('用于管理该企业下该产品的核心功能配置及授权。');
    const [regionMode, setRegionMode] = useState('whitelist');
    const [selectedCountries, setSelectedCountries] = useState(['CN', 'JP', 'KR']);
    const [regionModalVisible, setRegionModalVisible] = useState(false);
    const [regionForm] = Form.useForm();
    const [tempRemark, setTempRemark] = useState('');

    // App 默认生效配置详情弹窗状态
    const [isAppConfigModalOpen, setIsAppConfigModalOpen] = useState(false);
    const appDefaultConfig = [
        { label: '默认分辨率', value: '标清 (SD)' },
        { label: '插值设置', value: <div>图片插值: 关闭<br />视频插值: 关闭</div> },
        { label: '全彩模式时段', value: '定时开启' },
        { label: 'App 安全策略', value: '视频播放时长限制: 无限制' },
        { label: '一键报警配置', value: '不屏蔽' },
        { label: '假三目设置', value: '关闭' },
        { label: '灯控开关显示', value: '不显示' },
    ];

    // 定价相关状态
    const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(product.price || '0.00');
    const [tempPrice, setTempPrice] = useState(product.price || '0.00');

    // 套餐列表Drawer相关状态
    const [isPackageDrawerOpen, setIsPackageDrawerOpen] = useState(false);
    const [currentPackageAlgo, setCurrentPackageAlgo] = useState(null);
    const [drawerSource, setDrawerSource] = useState('algorithm'); // 'algorithm' 或 'platform'
    const [packageSearchValues, setPackageSearchValues] = useState({ name: '', id: '' });
    const [selectedPackageKey, setSelectedPackageKey] = useState(null);

    // 物模型抽屉状态
    const [modelDrawerVisible, setModelDrawerVisible] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const [activeMenu, setActiveMenu] = useState('联网方式');

    const tabLabelMap = { '1': '设备能力', '2': '镜头配置', '3': '麦克风配置', '4': '屏显配置', '5': '喇叭配置' };

    const [thingModelData, setThingModelData] = useState({
        '设备能力': {
            '配置选项': [
                '联网方式', '对讲设置', '存储设置', '电池设置', '工作模式', '唤醒能力', 'OTA能力', '指示灯', '红外灯', '报警录制'
            ],
            sharedStandard: [
                { type: '属性', name: '1234', identifier: '1234', dataType: 'Int(数字)', dataDef: '取值范围: 1 - 1', desc: '-', module: '-' },
                { type: '属性', name: '123', identifier: '123422', dataType: 'Int(数字)', dataDef: '取值范围: 123 - 2222', desc: '-', module: '官方测试3' }
            ],
            sharedCustom: [
                { type: '属性', name: '客流人数统计开关', identifier: 'CalcSwitch', dataType: 'Boolean(布尔)', dataDef: '开启-1 关闭-0', desc: '-', module: '-' }
            ],
            '联网方式': {
                config: [
                    { label: '联网方式', type: 'checkbox', options: ['有线', 'WIFI', '移动网络'], value: ['WIFI'] },
                    { label: '是否支持双频路由器', type: 'radio', options: ['否', '是'], value: '是' },
                    { label: '配网方式', type: 'checkbox', options: ['AP', '声音', 'smartlink', '摄像机识别二维码添加', '局域网', 'APP扫码添加', '蓝牙添加'], value: ['声音', 'smartlink'] }
                ]
            },
            '对讲设置': {
                config: [
                    { label: '对讲模式', type: 'radio', options: ['全双工', '半双工'], value: '全双工' },
                ]
            },
            '存储设置': { config: [] },
            '电池设置': { config: [] },
            '工作模式': { config: [] },
            '唤醒能力': { config: [] },
            'OTA能力': { config: [] },
            '指示灯': { config: [] },
            '红外灯': { config: [] },
            '报警录制': { config: [] }
        },
        '镜头配置': {
            '配置选项': ['多目配置', 'PTZ控制', '视频码流', '图像参数', '隐私区域', '水印', '鱼眼矫正', '高级选项'],
            'globalConfig': { label: '摄像机工作模式', options: ['独立工作', '联动工作'], value: '独立工作' },
            'cardTitle': '单目配置',
            'instanceName': 'Camera_1',
            'instanceLabel': '切换镜头',
            'sharedStandard': [
                { key: 'lens-1', type: '标准能力', name: '镜头状态', identifier: 'lens_status', dataType: '枚举', dataDef: '0:关闭, 1:开启', desc: '镜头开关状态', module: '镜头' }
            ],
            'sharedCustom': [],
            '多目配置': {
                multiTarget: [
                    { id: 1, label: '镜头 1', type: '普通镜头', maxFocal: 0, minFocal: 0 },
                    { id: 2, label: '镜头 2', type: '普通镜头', maxFocal: 0, minFocal: 0 }
                ]
            },
            'PTZ控制': { 
                config: [
                    { label: '是否支持PTZ', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: 'PTZ能力', type: 'checkbox', options: ['平移', '倾斜', '变焦'], value: [] },
                    { label: '是否支持预置位', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '是否支持自动巡航', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '空间定位能力', type: 'radio', options: ['不支持', '支持3D居中', '支持3D定位'], value: '不支持' },
                ] 
            },
            '视频码流': { config: [] },
            '图像参数': { config: [] },
            '隐私区域': { config: [] },
            '水印': { config: [] },
            '鱼眼矫正': { config: [] },
            '高级选项': { config: [] }
        },
        '麦克风配置': {
            '配置选项': ['麦克风参数配置', '音频码流配置'],
            'sharedStandard': [
                { key: 'mic-1', type: '标准能力', name: '采集音量', identifier: 'mic_volume', dataType: '数值', dataDef: '0-100', desc: '设置采集音量', module: '麦克风' }
            ],
            'sharedCustom': [],
            '麦克风参数配置': {
                instanceName: 'Microphone_1',
                config: [
                    { label: '麦克风开关', type: 'switch', value: false },
                    { label: '音量调节', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                    { label: '采集音量', type: 'input-number', value: 0 },
                    { label: '采样位深', type: 'radio', options: ['16bit', '24bit'], value: '16bit' },
                    { label: '采样率', type: 'radio', options: ['8000 (电话音质)', '16000 (语音识别常用)', '44100 (CD音质)', '48000 (专业音频常用)'], value: '8000 (电话音质)' },
                    { label: '声道数', type: 'radio', options: ['单声道', '双声道'], value: '单声道' },
                ]
            },
            '音频码流配置': {
                config: [
                    { label: '码流 1', type: 'title' },
                    { label: '支持的编码类型', type: 'checkbox', options: ['PCM', 'G711A', 'G711U', 'AAC', 'MP3'], value: [] },
                    { label: '默认编码类型', type: 'select', options: ['请选择'], value: '请选择' },
                ]
            }
        },
        '屏显配置': {
            '配置选项': [],
            'globalConfig': { label: '是否有屏显', options: ['是', '否'], value: '是' },
            'instanceName': 'Screen_1',
            'standard': [
                { key: 'disp-1', type: '标准能力', name: '屏幕亮度', identifier: 'screen_brightness', dataType: '数值', dataDef: '0-100', desc: '显示屏亮度调节', module: '屏显' }
            ],
            'custom': [],
            'config': [
                { label: '支持的分辨率', type: 'checkbox', options: ['1920*1080', '1280*720', '640*480', '640*360', '320*240'], value: [] },
                { label: '屏息时间 (秒)', type: 'input-number', value: 0 },
                { label: '支持的解码方式', type: 'checkbox', options: ['H264', 'H265', 'MJPG'], value: [] },
                { label: '支持的屏显类型', type: 'checkbox', options: ['文字', '背景图', '图片', '视频'], value: [] },
            ]
        },
        '喇叭配置': {
            '配置选项': [],
            'globalConfig': { label: '是否有喇叭', options: ['是', '否'], value: '是' },
            'instanceName': 'Speaker_1',
            'standard': [
                { key: 'spk-1', type: '标准能力', name: '播放音量', identifier: 'speaker_volume', dataType: '数值', dataDef: '0-100', desc: '扬声器播放音量', module: '喇叭' }
            ],
            'custom': [],
            'config': [
                { label: '支持的编码方式', type: 'checkbox', options: ['PCM', 'G711A', 'g711u', 'ACC'], value: [] },
                { label: '音量调节', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                { label: '音量', type: 'input-number', value: 0 },
                { label: '自定义铃声', type: 'radio', options: ['支持', '不支持'], value: '不支持' },
                { label: '采样位深', type: 'radio', options: ['16bit', '24bit'], value: '16bit' },
                { label: '采样率', type: 'radio', options: ['8000 (电话音质)', '16000 (语音识别常用)', '44100 (CD音质)', '48000 (专业音频常用)'], value: '8000 (电话音质)' },
                { label: '声道数', type: 'radio', options: ['单声道', '双声道'], value: '单声道' },
            ]
        }
    });

    const getActiveData = () => {
        const currentTabLabel = tabLabelMap[activeTab];
        const tabData = thingModelData[currentTabLabel];
        const defaultData = { config: [], standard: [], custom: [] };
        if (!tabData) return defaultData;

        if (!tabData['配置选项'] || tabData['配置选项'].length === 0) {
            return {
                config: tabData.config || [],
                multiTarget: tabData.multiTarget || [],
                standard: tabData.standard || [],
                custom: tabData.custom || [],
                globalConfig: tabData.globalConfig,
                alert: tabData.alert,
                hideTables: tabData.hideTables
            };
        }

        const menuData = tabData[activeMenu] || defaultData;
        const sharedTabs = ['设备能力', '镜头配置', '麦克风配置', '屏显示配置', '喇叭配置'];

        if (sharedTabs.includes(currentTabLabel)) {
            return {
                ...tabData,
                ...menuData,
                multiTarget: menuData.multiTarget || [],
                standard: tabData.sharedStandard || tabData.standard || [],
                custom: tabData.sharedCustom || tabData.custom || []
            };
        }

        return menuData;
    };

    const activeData = getActiveData();

    // 物模型数据更新辅助函数
    const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

    const updateGlobalConfig = (newValue) => {
        setThingModelData(prev => {
            const d = deepClone(prev);
            const tabKey = tabLabelMap[activeTab];
            if (d[tabKey] && d[tabKey].globalConfig) {
                d[tabKey].globalConfig.value = newValue;
            }
            return d;
        });
    };

    const updateConfigItem = (index, newValue) => {
        setThingModelData(prev => {
            const d = deepClone(prev);
            const tabKey = tabLabelMap[activeTab];
            const tabData = d[tabKey];
            if (!tabData) return prev;
            if (tabData['配置选项'] && tabData['配置选项'].length > 0) {
                if (tabData[activeMenu] && tabData[activeMenu].config) {
                    tabData[activeMenu].config[index].value = newValue;
                }
            } else if (tabData.config) {
                tabData.config[index].value = newValue;
            }
            return d;
        });
    };

    const updateMultiTarget = (index, field, newValue) => {
        setThingModelData(prev => {
            const d = deepClone(prev);
            const tabKey = tabLabelMap[activeTab];
            if (d[tabKey] && d[tabKey][activeMenu] && d[tabKey][activeMenu].multiTarget) {
                d[tabKey][activeMenu].multiTarget[index][field] = newValue;
            }
            return d;
        });
    };

    const packageData = [
        { key: '1', id: 'PKG001', name: '基础版算法包', desc: '包含基础人形和运动检测' },
        { key: '2', id: 'PKG002', name: '高级视觉版', desc: '包含人脸识别和行为分析' },
        { key: '3', id: 'PKG003', name: '全能看护版', desc: '包含哭声检测和老人看护' },
        { key: '4', id: 'PKG004', name: '商用专业版', desc: '包含客流统计和区域侦测' },
    ];

    const filteredPackages = packageData.filter(item => 
        item.name.includes(packageSearchValues.name) && item.id.includes(packageSearchValues.id)
    );

    // 算法列表数据 (用于下方插入的卡片) - 企业权限
    const [algorithmData, setAlgorithmData] = useState([        
        { id: '1000', _mergeFirst: true, service_id: '300026', svcName: '人形检测服务', name: '人形检测', desc: '智能过滤非人物体，精确识别人物', supported: false, isFree: false, packageName: '' },
        { id: '1000', _mergeFirst: false, service_id: '300027', svcName: '运动检测服务', name: '运动检测', desc: '监测画面中像素发生位移变化', supported: false, isFree: false, packageName: '' },
        { id: '1011', service_id: '3000XX', svcName: '云端抓图服务', name: '云端抓图', desc: '设备端云端抓图配置', supported: false, isFree: false, packageName: '' },
        { id: '1003', service_id:'300048',name: 'PIR红外检测', desc: '基于红外热释电的人体活动监测', supported: false, isFree: false, packageName: '' },
        { id: '1004', service_id:'300037',name: '声音检测', desc: '环境分贝异常或尖锐声响检测', supported: false, isFree: false, packageName: '' },
        { id: '1016', service_id:'300036',name: '逗留提醒', desc: '目标在特定区域内停留时间预警，关联设备算法1061的算法ID=14', supported: false },
        { id: '1018', service_id:'300033',name: '人物(人脸)识别', desc: '智能识别特定人物', supported: false },
        { id: '1021', service_id:'300028',name: '低电检测', desc: '电池电量不足时主动预警', supported: false },
        { id: '1024', service_id:'300020',name: '跌倒检测', desc: '检测到突发性的摔倒动作', supported: false },
        { id: '1025', service_id:'300022',name: '火焰检测', desc: '针对明火的快速识别报警', supported: false },
        { id: '1028', service_id:'300023',name: '哭声检测', desc: '灵敏识别婴儿哭泣或呼救声', supported: false },
        { id: '1029', service_id:'300024',name: '宠物检测', desc: '精确识别猫、狗等宠物活动', supported: false },
        { id: '1037', service_id:'300029',name: '呼叫服务', desc: '支持语音及视频呼叫功能', supported: false },
        { id: '1070', service_id:'300043',name: '离岗侦测', desc: '监测工作人员离开固定职守岗位', supported: false },
        { id: '1079', service_id:'300034',name: '区域闯入', desc: '目标跨线进入警戒区', supported: true },
        { id: '1080', service_id:'300035',name: '区域离开', desc: '目标跨线离开受控区', supported: true },
        { id: '1082', service_id:'300038',name: '烟火侦测', desc: '实时监测烟雾和火苗风险', supported: false },
        { id: '1083', service_id:'300017',name: '车辆侦测', desc: '识别进入画面的各类机动车辆', supported: false },
        { id: '1086', service_id:'300047',name: '非机动车检测', desc: '识别画面中的脚踏车、人力车等', supported: false },
        { id: '1088', service_id:'300019',name: '车牌识别', desc: '自动读取并识别车牌信息', supported: false },
        { id: '1090', service_id:'300045',name: '客流统计', desc: '进入/出去行为识别与计数', supported: false },
        { id: '1093', service_id:'300008',name: '离线监控', desc: '设备断电或离线时的状态监测', supported: true },
        { id: '1098', service_id:'300009',name: '智能告警服务', desc: '基于多维参数的综合告警策略', supported: false },
        { id: '1096', service_id:'300044',name: '智能告警-儿童检测', desc: '综合全天候的儿童看护识别', supported: false },
        { id: '1103', service_id:'300039',name: '智能告警-老人看护', desc: '针对老年用户的异常行为识别', supported: false },
        { id: '1104', service_id:'300040',name: '智能告警-厨房监测', desc: '全方位监测厨房油烟和火情', supported: false },
        { id: '1105', service_id:'300041',name: '智能告警-家门检测', desc: '门口逗留、门缝检测等安防预警', supported: false },
        { id: '1106', service_id:'300042',name: '智能告警-宠物检测', desc: '整合宠物的多项健康和活动指标', supported: false },
        { id: '1108', service_id:'300050',name: 'GPS信息处理', desc: '设备地理位置定位与上报', supported: false },
        { id: '1109', service_id:'300025',name: '包裹侦测', desc: '检测门口或指定区域堆放的包裹', supported: false },
        { id: '1111', service_id:'300046',name: '鱼类检测', desc: '针对水族箱场景的特定识别', supported: false },
        { id: '1112', service_id:'300018',name: '人脸检测', desc: '检测画面中出现的人脸', supported: true },
        { id: '1114', service_id:'300049',name: '宠物喂食', desc: '监测宠物进食与自动喂食器联动', supported: false },
    ]);

    // 平台服务数据
    const [platformServices, setPlatformServices] = useState([
        { key: 'pc1', id: '1010', _m: true, name: '云存录像', service_id: '300010', svcName: '事件云存', desc: '用于存储录制事件', supported: true, isFree: false, packageName: '' },
        { key: 'pc2', id: '1010', _m: false, service_id: '300011', svcName: '全天云存', desc: '用于存储视频回看', supported: true, isFree: false, packageName: '' },
        { key: 'pv1', id: '1063', _m: true, name: '语音助手', service_id: '300005', svcName: 'Alexa', desc: '接入Amazon Alexa', supported: true, isFree: false, packageName: '' },
        { key: 'pv2', id: '1063', _m: false, service_id: '300006', svcName: 'Google Home', desc: '接入Google Home', supported: true, isFree: false, packageName: '' },
        { key: 'ts1', id: '1100', name: '时光相册', service_id: '300007', svcName: '时光相册', desc: '生成精彩瞬间的时间轴视图', supported: true, isFree: false, packageName: '' },
    ]);
    // 平台服务算法配置抽屉
    const [platAlgoDrawer, setPlatAlgoDrawer] = useState(false);
    const [platAlgoConfig, setPlatAlgoConfig] = useState({ id: '', streamType: 'sub', workMode: 'cloud' });


    const interactionConfigData = [ // eslint-disable-line no-unused-vars
        {
            group: 'APP路径配置',
            items: [
                { label: '功能名称', value: '1234', module: '设备能力', desc: '-', path: '/pages/device/control' },
                { label: '功能名称', value: '客流统计', module: '设备能力', desc: '-', path: '/pages/device/stat' }
            ]
        },
        {
            group: '语音控制',
            items: [
                { label: 'Alexa(语音助手)', value: '已接入', type: 'checked' },
                { label: 'Google Home', value: '已接入', type: 'checked' },
                { label: '天猫精灵', value: '未接入', type: 'radio' }
            ]
        },
        {
            group: '推送配置',
            items: [
                { label: '报警消息', value: '设备侦测到移动目标', status: '已开启', type: 'switch' },
                { label: '系统消息', value: '设备上线/下线通知', status: '已开启', type: 'switch' }
            ]
        }
    ];

    const showDetail = (title, data, type = 'list') => { // eslint-disable-line no-unused-vars
        setModalConfig({ title, dataSource: data, type });
        setIsDetailModalOpen(true);
    };

    const handleEditRemark = () => {
        setTempRemark(remark);
        setIsEditingRemark(true);
    };

    const handleSaveRemark = () => {
        setRemark(tempRemark);
        setIsEditingRemark(false);
        message.success('管理员备注已更新');
    };

    const handleCancelRemark = () => {
        setIsEditingRemark(false);
    };

    const [isFirmwareDrawerOpen, setIsFirmwareDrawerOpen] = useState(false);
    const [selectedFirmware] = useState(null);

    const firmwareHistoryData = [
        { key: '1', index: 1, version: '23.12.31.1.1', sdkVersion: '2', type: '升级固件', testStatus: '待测试', otaStatus: '待测试', publishStatus: '已上架', desc: '首发版本，支持基础P2P流媒体传输', createTime: '2026-01-26 10:22:29' },
        { key: '2', index: 2, version: '2026.01.24.1', sdkVersion: '2', type: '生产固件', testStatus: '待测试', otaStatus: '待测试', publishStatus: '已上架', desc: '工厂预装版本', createTime: '2026-01-24 16:08:27' },
        { key: '3', index: 3, version: '2026.01.15.5', sdkVersion: '1', type: '升级固件', testStatus: '已通过', otaStatus: '已通过', publishStatus: '已下架', desc: '修复了已知的安全漏洞', createTime: '2026-01-15 09:15:00' },
        { key: '4', index: 4, version: '2025.12.20.2', sdkVersion: '1', type: '升级固件', testStatus: '已通过', otaStatus: '已通过', publishStatus: '已下架', desc: '优化弱网环境连接稳定性', createTime: '2025-12-20 14:30:12' },
        { key: '5', index: 5, version: '2025.11.05.1', sdkVersion: '1', type: '生产固件', testStatus: '已通过', otaStatus: '已通过', publishStatus: '已下架', desc: '初始版本发布', createTime: '2025-11-05 11:00:45' },
    ];

    const firmwareHistoryColumns = [
        { title: '序号', dataIndex: 'index', key: 'index', width: 60 },
        { 
            title: '固件版本号', 
            dataIndex: 'version', 
            key: 'version',
            render: (text) => <Text>{text}</Text>
        },
        { title: 'SDK版本号', dataIndex: 'sdkVersion', key: 'sdkVersion' },
        { title: '固件类型', dataIndex: 'type', key: 'type' },
        { 
            title: '固件测试', 
            dataIndex: 'testStatus', 
            key: 'testStatus',
            render: (text) => (
                <Tag color={text === '已通过' ? 'success' : 'default'} bordered={false}>
                    {text}
                </Tag>
            )
        },
        { 
            title: 'OTA能力测试', 
            dataIndex: 'otaStatus', 
            key: 'otaStatus',
            render: (text) => <Tag bordered={false}>{text}</Tag>
        },
        { title: '上架状态', dataIndex: 'publishStatus', key: 'publishStatus' },
        { title: '版本描述', dataIndex: 'desc', key: 'desc', ellipsis: true },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
        { 
            title: '操作', 
            key: 'action',
            render: () => (
                <Space size="middle">
                    <Button type="link" size="small" style={{ padding: 0 }}>下载</Button>
                </Space>
            )
        },
    ];

    const firmwareData = [
        {
            key: '1',
            name: 'P2P网络摄像头固件',
            version: 'v2.3.5_20240305',
            versionCount: 12,
            desc: '优化了低光环境下的图像噪点，修复了部分WiFi环境下断连的问题，增强了ONVIF协议兼容性。',
            updateTime: '2026-03-05 10:48:39'
        },
        {
            key: '2',
            name: 'AI人形检测驱动',
            version: 'v1.0.8',
            versionCount: 4,
            desc: '提升了侧脸识别准确率，降低了宠物误报率。',
            updateTime: '2026-03-04 16:53:40'
        }
    ];

    const columns = [
        { title: '固件名称', dataIndex: 'name', key: 'name' },
        { 
            title: '固件版本', 
            dataIndex: 'version', 
            key: 'version',
            render: (text) => <Tag color="blue" bordered={false} style={{ borderRadius: 4 }}>{text}</Tag>
        },
        { 
            title: '固件说明', 
            dataIndex: 'desc', 
            key: 'desc',
            width: '35%',
            render: (text) => <Text type="secondary" ellipsis={{ tooltip: text }}>{text}</Text>
        },
        { title: '创建时间', dataIndex: 'updateTime', key: 'updateTime' }
    ];

    const handleAudit = () => {
        setAuditResult('pass');
        auditForm.setFieldsValue({
            price: currentPrice,
            result: 'pass',
            reason: ''
        });
        setIsAuditModalOpen(true);
    };

    const handleAuditSubmit = () => {
        auditForm.validateFields().then(values => {
            message.success('审核已提交');
            setIsAuditModalOpen(false);
            // 这里通常会调用 API 更新状态并返回列表
            navigate('/product/product-audit');
        });
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Breadcrumb>
                    <Breadcrumb.Item onClick={() => navigate('/product/audit')} style={{ cursor: 'pointer' }}>产品审核</Breadcrumb.Item>
                    <Breadcrumb.Item>产品管理：{product.productName} {(() => {
                        if (product.source === 'ecosystem') return <><Tag color="blue" style={{ marginLeft: 8 }}>基于方案</Tag><Text type="secondary" style={{ fontSize: 12, marginLeft: 4 }}>方案商：{product.vendorName || '-'} | 方案产品：{product.vendorProductName || '-'}（{product.vendorProductId || '-'}）</Text></>;
                        return <Tag color="green" style={{ marginLeft: 8 }}>自研开发</Tag>;
                    })()}</Breadcrumb.Item>
                </Breadcrumb>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>返回列表</Button>
            </div>

            <Card style={{ marginBottom: 16 }} bodyStyle={{ padding: '0 0 16px 0' }}>
                <Descriptions 
                    title={<div style={{ padding: '16px 24px 0 24px' }}>基本信息</div>} 
                    bordered 
                    size="small"
                >
                    <Descriptions.Item label="产品名称">{product.productName}</Descriptions.Item>
                    <Descriptions.Item label="产品ID">{product.productId}</Descriptions.Item>
                    <Descriptions.Item label="产品类目">{product.category}</Descriptions.Item>
                    <Descriptions.Item label="所属企业">{product.enterpriseName}</Descriptions.Item>
                    <Descriptions.Item label="企业ID">{product.enterpriseId || '-'}</Descriptions.Item>
                    <Descriptions.Item label="当前状态">
                        <Space>
                            <Tag color={statusConfig[product.status]?.color || 'default'} bordered={false}>
                                {statusConfig[product.status]?.text || product.status}
                            </Tag>
                            {product.status === '待审核' && (
                                <Button 
                                    type="link" 
                                    danger
                                    size="small" 
                                    icon={<EditOutlined />}
                                    onClick={handleAudit}
                                    style={{ fontWeight: '500' }}
                                >
                                    去审核
                                </Button>
                            )}
                        </Space>
                    </Descriptions.Item>
                    <Descriptions.Item label="授权单价">
                        <Space>
                            <span style={{ fontWeight: 'bold', color: '#f5222d', fontSize: '16px' }}>¥{currentPrice}</span>
                            <Button 
                                type="link" 
                                size="small" 
                                icon={<EditOutlined />} 
                                onClick={() => {
                                    setTempPrice(currentPrice);
                                    setIsPriceModalOpen(true);
                                }}
                            >
                                修改定价
                            </Button>
                        </Space>
                    </Descriptions.Item>
                    <Descriptions.Item label="管理员备注" span={2}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ flex: 1, marginRight: 16 }}>
                                {remark}
                            </div>
                            <Button 
                                type="link" 
                                size="small" 
                                icon={<EditOutlined />} 
                                onClick={handleEditRemark}
                                style={{ padding: '0 4px' }}
                            >
                                修改备注
                            </Button>
                        </div>
                    </Descriptions.Item>
                    <Descriptions.Item label="设备使用区域" span={2}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ flex: 1 }}>
                                {regionMode === 'none' ? (
                                    <Tag>不限制</Tag>
                                ) : (
                                    <div>
                                        <Tag color={regionMode === 'whitelist' ? 'green' : 'red'}>{regionMode === 'whitelist' ? '白名单' : '黑名单'}</Tag>
                                        <div style={{ marginTop: 4 }}>
                                            {selectedCountries.map(c => {
                                                const map = { CN: '中国', US: '美国', JP: '日本', KR: '韩国', DE: '德国', GB: '英国', FR: '法国', AU: '澳大利亚', IN: '印度', BR: '巴西', CA: '加拿大', RU: '俄罗斯', SG: '新加坡', TH: '泰国', VN: '越南' };
                                                return <Tag key={c} style={{ marginBottom: 2 }}>{map[c] || c}</Tag>;
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <Button type="link" size="small" icon={<EditOutlined />} onClick={() => { regionForm.setFieldsValue({ regionMode, selectedCountries }); setRegionModalVisible(true); }} style={{ padding: '0 4px' }}>设置</Button>
                        </div>
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            {/* 产品审核 Modal */}
            <Modal
                title="产品审核"
                open={isAuditModalOpen}
                onOk={handleAuditSubmit}
                onCancel={() => setIsAuditModalOpen(false)}
                width={600}
                okText="确认审核"
                cancelText="取消"
            >
                <Form
                    form={auditForm}
                    layout="vertical"
                    initialValues={{ result: 'pass' }}
                >
                    <Descriptions bordered column={1} size="small" style={{ marginBottom: 20 }}>
                        <Descriptions.Item label="产品名称">{product.productName}</Descriptions.Item>
                        <Descriptions.Item label="产品ID">{product.productId}</Descriptions.Item>
                        {/* <Descriptions.Item label="申请价格">￥ {product.price}</Descriptions.Item> */}
                    </Descriptions>

                    <Form.Item
                        name="result"
                        label="审核结果"
                        rules={[{ required: true }]}
                    >
                        <Radio.Group onChange={(e) => setAuditResult(e.target.value)}>
                            <Radio value="pass">通过</Radio>
                            <Radio value="reject">驳回</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {auditResult === 'pass' ? (
                        <Form.Item
                            name="price"
                            label="授权单价 (元/个)"
                            rules={[{ required: true, message: '请输入定价' }]}
                        >
                            <Input prefix="￥" placeholder="请输入最终审核后的价格" />
                        </Form.Item>
                    ) : (
                        <Form.Item
                            name="reason"
                            label="驳回原因"
                            rules={[{ required: true, message: '请填写驳回原因' }]}
                        >
                            <TextArea rows={4} placeholder="请输入具体的驳回理由" />
                        </Form.Item>
                    )}
                </Form>
            </Modal>

            {/* 修改定价的 Modal */}
            <Modal
                title="修改产品授权定价"
                open={isPriceModalOpen}
                onOk={() => {
                    setCurrentPrice(tempPrice);
                    setIsPriceModalOpen(false);
                    message.success('产品定价已成功更新');
                }}
                onCancel={() => setIsPriceModalOpen(false)}
                okText="确认修改"
                cancelText="取消"
                width={480}
                destroyOnClose
            >
                <div style={{ padding: '8px 0' }}>
                    <Form 
                        layout="horizontal" 
                        labelCol={{ span: 6 }} 
                        wrapperCol={{ span: 16 }}
                        labelAlign="right"
                    >
                        <Form.Item label="产品名称">
                            <Text strong>{product.productName}</Text>
                        </Form.Item>
                        <Form.Item label="产品 ID">
                            <Text strong>{product.productId}</Text>
                        </Form.Item>
                        <Form.Item label="当前定价">
                            <Text strong>¥{currentPrice}</Text>
                        </Form.Item>
                        <Form.Item label="新授权单价" required>
                            <InputNumber 
                                style={{ width: '100%' }}
                                min={0}
                                precision={2}
                                step={0.01}
                                prefix="¥"
                                value={tempPrice}
                                onChange={(val) => setTempPrice(val)}
                                placeholder="请输入新的授权单价"
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>

            {/* 修改备注的 Modal */}
            <Modal
                title="修改管理员备注"
                open={isEditingRemark}
                onOk={handleSaveRemark}
                onCancel={handleCancelRemark}
                okText="保存"
                cancelText="取消"
                destroyOnClose
            >
                <div style={{ marginBottom: 8 }}>请输入新的管理员备注信息：</div>
                <Input.TextArea 
                    rows={4} 
                    value={tempRemark} 
                    onChange={(e) => setTempRemark(e.target.value)}
                    placeholder="请输入备注内容..."
                    maxLength={200}
                    showCount
                />
            </Modal>

            <Row gutter={16} style={{ marginBottom: 16 }}>
                {[
                    { 
                        title: '物模型配置', 
                        sub: (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <Text type="secondary" style={{ fontSize: 13, fontWeight: 'normal' }}>已配置设备能力、镜头、麦克风等 5 个子项</Text>
                                <Button 
                                    type="link" 
                                    size="small" 
                                    onClick={() => {
                                        setActiveTab('1');
                                        setModelDrawerVisible(true);
                                    }}
                                    style={{ padding: '0 4px', fontWeight: 'normal' }}
                                >
查看/修改
                                </Button>
                            </div>
                        ), 
                        icon: <AppstoreOutlined />, 
                        color: '#1890ff' 
                    },
                    {
                        title: '设备算法',
                        sub: <Text type="secondary" style={{ fontSize: 13 }}>已配置 {algorithmData.filter(a => a.supported).length} 项</Text>,
                        icon: <AppstoreOutlined />, color: '#722ed1'
                    },
                    {
                        title: '平台服务',
                        sub: <Text type="secondary" style={{ fontSize: 13 }}>已配置 {platformServices.filter(s => s.supported).length} 项</Text>,
                        icon: <AppstoreOutlined />, color: '#eb2f96'
                    }
                ].map((item, index) => (
                    <Col span={8} key={index}>
                        <Card bordered={false} bodyStyle={{ padding: '16px 24px' }} style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <div style={{ width: 44, height: 44, borderRadius: 8, backgroundColor: item.color + '15', color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>
                                    {item.icon}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ color: '#8c8c8c', fontSize: 13, marginBottom: 4 }}>{item.title}</div>
                                    <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>{item.sub}</div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* 标准功能 / 自定义功能编辑弹窗 */}
            <Modal
                title="编辑物模型能力"
                open={isAbilityDrawerOpen}
                onCancel={() => setIsAbilityDrawerOpen(false)}
                footer={[
                    <Button key="close" type="primary" onClick={() => setIsAbilityDrawerOpen(false)}>完成</Button>
                ]}
                width={1000}
                style={{ top: 40 }}
            >
                <Tabs 
                    activeKey={activeAbilityTab} 
                    onChange={setActiveAbilityTab}
                    items={[
                        {
                            key: 'standard',
                            label: '标准功能',
                            children: (
                                <div style={{ padding: '8px 0' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                        <Space>
                                            <Title level={4} style={{ margin: 0 }}>标准能力</Title>
                                            <InfoCircleOutlined style={{ color: '#bfbfbf' }} />
                                        </Space>
                                        <Button type="primary" size="small" onClick={() => setIsAddAbilityModalOpen(true)}>添加标准能力</Button>
                                    </div>
                                    <Table 
                                        size="small"
                                        pagination={false}
                                        columns={[
                                            { title: '类型', dataIndex: 'type', key: 'type' },
                                            { title: '能力名称', dataIndex: 'name', key: 'name' },
                                            { title: '能力标识', dataIndex: 'id', key: 'id' },
                                            { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                            { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                            { title: '所属模块', dataIndex: 'module', key: 'module' },
                                            { 
                                                title: '操作', 
                                                key: 'action',
                                                render: (_, record) => (
                                                    <Space>
                                                        <Button type="link" size="small">编辑</Button>
                                                        <Button type="link" size="small" danger onClick={() => {
                                                            setStandardAbilities(standardAbilities.filter(a => a.key !== record.key));
                                                        }}>删除</Button>
                                                    </Space>
                                                )
                                            }
                                        ]}
                                        dataSource={standardAbilities}
                                    />
                                </div>
                            )
                        },
                        {
                            key: 'custom',
                            label: '自定义功能',
                            children: (
                                <div style={{ padding: '8px 0' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                        <Space>
                                            <Title level={4} style={{ margin: 0 }}>自定义能力</Title>
                                            <Text type="secondary" style={{ fontSize: 12 }}>自定义功能目前仅支持查看</Text>
                                        </Space>
                                    </div>
                                    <Table 
                                        size="small"
                                        pagination={false}
                                        columns={[
                                            { title: '类型', dataIndex: 'type', key: 'type' },
                                            { title: '能力名称', dataIndex: 'name', key: 'name' },
                                            { title: '能力标识', dataIndex: 'id', key: 'id' },
                                            { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                            { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                            { title: '描述', dataIndex: 'desc', key: 'desc' }
                                        ]}
                                        dataSource={[
                                            { key: 'c1', type: '属性', name: '客流人数统计开关', id: 'CalcSwitch', dataType: 'Boolean(布尔)', dataDef: '开启-1 关闭-0', desc: '' },
                                            { key: 'c2', type: '事件', name: '测试能力事件', id: 'TEST1226', dataType: '-', dataDef: '-', desc: '' }
                                        ]}
                                    />
                                </div>
                            )
                        }
                    ]}
                />
            </Modal>

            {/* 添加标准能力弹窗 (图2样式) */}
            <Modal
                title="添加能力"
                open={isAddAbilityModalOpen}
                onCancel={() => setIsAddAbilityModalOpen(false)}
                onOk={() => {
                    message.success('已成功添加 1 项能力');
                    setIsAddAbilityModalOpen(false);
                }}
                width={800}
                centered
            >
                <Row gutter={24} align="middle">
                    <Col span={11}>
                        <Card title={<div style={{ display: 'flex', justifyContent: 'space-between' }}><span>未添加能力</span><span>0/7</span></div>} size="small">
                            <Input prefix={<SettingOutlined />} placeholder="输入名称搜索" style={{ marginBottom: 12 }} />
                            <div style={{ height: 260, overflowY: 'auto' }}>
                                <List
                                    size="small"
                                    dataSource={[
                                        { name: '1234', id: '1234', type: 'Int(数字)' },
                                        { name: '123', id: '123422', type: 'Int(数字)' },
                                        { name: '摄像机开关', id: 'CameraSwitch', type: 'Boolean(布尔)' },
                                        { name: '白光灯', id: 'WhiteLight', type: 'Boolean(布尔)' }
                                    ]}
                                    renderItem={item => (
                                        <List.Item>
<Checkbox>{item.name} <Tag color="blue" size="small" style={{ fontSize: 10, lineHeight: '16px' }}>属性</Tag></Checkbox>
                                                    <div style={{ fontSize: 11, color: '#8c8c8c', paddingLeft: 24 }}>能力标识:{item.id} &nbsp; 数据类型:{item.type}</div>
                                                </List.Item>
                                            )}
                                        />
                                    </div>
                                </Card>
                            </Col>
                            <Col span={2} style={{ textAlign: 'center' }}>
                                <Space direction="vertical">
                                    <Button icon={<ArrowLeftOutlined style={{ transform: 'rotate(180deg)' }} />} size="small" />
                                    <Button icon={<ArrowLeftOutlined />} size="small" />
                                </Space>
                            </Col>
                            <Col span={11}>
                                <Card title={<div style={{ display: 'flex', justifyContent: 'space-between' }}><span>已添加能力</span><span style={{ fontSize: 12, fontWeight: 'normal' }}>0/1</span></div>} size="small">
                                    <Input prefix={<SettingOutlined />} placeholder="输入名称搜索" style={{ marginBottom: 12 }} />
                                    <div style={{ height: 320, overflowY: 'auto' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ marginBottom: 12 }}>
                                                <Checkbox>关联子算法 <Tag color="blue" size="small" style={{ fontSize: 10, lineHeight: '16px' }}>属性</Tag></Checkbox>
                                                <div style={{ fontSize: 11, color: '#8c8c8c', paddingLeft: 24 }}>能力标识:SubAlgorithmType &nbsp; 数据类型:String(字符串)</div>
                                            </div>
                                        </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Modal>


            <Card 
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: 15, fontWeight: 600 }}>设备算法服务</span>
                        <Button type="primary" size="small" onClick={() => message.success('设备算法配置已保存')}>保存配置</Button>
                    </div>
                } 
                bordered={false} 
                style={{ borderRadius: 12, marginBottom: 16 }}
            >
                <Table size="small" pagination={false} dataSource={algorithmData}
                    columns={[
                        { title: 'ID(AIIoTType)', dataIndex: 'id', width: 100, onCell: r => ({ rowSpan: r._mergeFirst === true ? 2 : r._mergeFirst === false ? 0 : 1 }), render: t => <Text code>{t}</Text> },
                        { title: '算法名称', dataIndex: 'name', width: 120, onCell: r => ({ rowSpan: r._mergeFirst === true ? 2 : r._mergeFirst === false ? 0 : 1 }), render: t => <Text strong>{t}</Text> },
                        { title: '算法描述', dataIndex: 'desc', ellipsis: true, onCell: r => ({ rowSpan: r._mergeFirst === true ? 2 : r._mergeFirst === false ? 0 : 1 }) },
                        { title: '算法配置', width: 100, onCell: r => ({ rowSpan: r._mergeFirst === true ? 2 : r._mergeFirst === false ? 0 : 1 }), render: () => <Button type="link" size="small">配置</Button> },
                        { title: '关联事件', width: 100, onCell: r => ({ rowSpan: r._mergeFirst === true ? 2 : r._mergeFirst === false ? 0 : 1 }), render: () => <Button type="link" size="small">配置</Button> },
                        { title: '服务ID', dataIndex: 'service_id', width: 100, render: t => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                        { title: '服务名称', width: 120, render: (_, r) => <Text strong>{r.svcName || r.name}</Text> },
                        { title: '是否支持', dataIndex: 'supported', width: 80, render: (v, r) => (
                            <Switch size="small" checked={v} onChange={checked => setAlgorithmData(algorithmData.map(a => a.service_id === r.service_id ? { ...a, supported: checked, isFree: checked ? a.isFree : false } : a))} />
                        )},
                        { title: '免开通', dataIndex: 'isFree', width: 80, render: (v, r) => (
                            <Switch size="small" checked={v} disabled={!r.supported} checkedChildren="是" unCheckedChildren="否" onChange={c => setAlgorithmData(algorithmData.map(a => a.service_id === r.service_id ? { ...a, isFree: c } : a))} />
                        )},
                    ]}
                />
            </Card>

            <Card 
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: 15, fontWeight: 600 }}>平台服务</span>
                        <Button type="primary" size="small" onClick={() => message.success('平台服务配置已保存')}>保存配置</Button>
                    </div>
                } 
                bordered={false} 
                style={{ borderRadius: 12, marginBottom: 16 }}
            >
                <Alert message="是否免开通：开启并保存后，系统将自动向该产品赠送对应的算法服务。C端用户无需再付费购买。" type="info" showIcon style={{ marginBottom: 16, borderRadius: 8 }} />
                <Table size="small" pagination={false}
                    dataSource={platformServices}
                    columns={[
                        { title: 'ID(AIIoTType)', dataIndex: 'id', width: 100, onCell: r => ({ rowSpan: r._m === true ? 2 : r._m === false ? 0 : 1 }), render: t => <Text code>{t}</Text> },
                        { title: '算法名称', dataIndex: 'name', width: 100, onCell: r => ({ rowSpan: r._m === true ? 2 : r._m === false ? 0 : 1 }), render: t => t ? <Text strong>{t}</Text> : null },
                        { title: '算法配置', width: 100, onCell: r => ({ rowSpan: r._m === true ? 2 : r._m === false ? 0 : 1 }), render: (_, r) => <Button type="link" size="small" onClick={() => { setPlatAlgoConfig({ id: r.id }); setPlatAlgoDrawer(true); }}>配置</Button> },
                        { title: '服务ID', dataIndex: 'service_id', width: 90, render: t => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                        { title: '服务名称', dataIndex: 'svcName', width: 120, render: t => <Text strong>{t}</Text> },
                        { title: '服务描述', dataIndex: 'desc', ellipsis: true },
                        { title: '是否支持', dataIndex: 'supported', width: 80, render: (v, r) => (
                            <Switch size="small" checked={v} onChange={c => setPlatformServices(platformServices.map(s => s.key === r.key ? { ...s, supported: c, isFree: c ? s.isFree : false } : s))} />
                        )},
                        { title: '免开通', dataIndex: 'isFree', width: 80, render: (v, r) => (
                            <Switch size="small" checked={v} disabled={!r.supported} onChange={c => setPlatformServices(platformServices.map(s => s.key === r.key ? { ...s, isFree: c } : s))} />
                        )},
                        { title: '关联套餐', width: 140, render: (_, r) => (
                            <Button size="small" type="link" disabled={!r.isFree} onClick={() => { setCurrentPackageAlgo(r); setDrawerSource('platform'); setSelectedPackageKey(null); setIsPackageDrawerOpen(true); }}>{r.packageName || '配置'}</Button>
                        )},
                    ]}
                />
            </Card>

            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Card 
                        title={<span style={{ fontSize: 15, fontWeight: 600 }}>App配置</span>} 
                        bordered={false} 
                        style={{ borderRadius: 8 }}
                        extra={
                            <Button 
                                type="link" 
                                onClick={() => navigate('/product/app')}
                                icon={<SettingOutlined />}
                            >
                                前往查看/修改
                            </Button>
                        }
                    >
                        <Row gutter={16}>
                            {[
                                { 
                                    title: '安装指引', 
                                    icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />, 
                                    data: [
                                        { label: '配置状态', value: '已配置', type: 'tag', color: 'green' }
                                    ]
                                },
                                { 
                                    title: '应用App', 
                                    icon: <AppstoreOutlined style={{ color: '#52c41a' }} />, 
                                    data: [
                                        { label: '使用权限', value: '不限制 / 限制使用4个App', type: 'text', strong: true }
                                    ]
                                },
                                { 
                                    title: '默认生效配置', 
                                    icon: <SettingOutlined style={{ color: '#faad14' }} />, 
                                    data: [
                                        { label: '配置详情', value: '查看详情', type: 'app-config-details' }
                                    ]
                                }
                            ].map((section, idx) => (
                                <Col span={8} key={idx}>
                                    <div style={{ padding: '4px 8px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                            {section.icon}
                                            <Text strong>{section.title}</Text>
                                        </div>
                                        <List
                                            size="small"
                                            dataSource={section.data}
                                            renderItem={item => (
                                                <List.Item style={{ padding: '4px 0', border: 'none' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: 13 }}>
                                                        <Text type="secondary">{item.label}:</Text>
                                                        {item.type === 'app-config-details' ? (
                                                            <Button 
                                                                type="link" 
                                                                size="small" 
                                                                style={{ padding: 0, height: 'auto' }} 
                                                                onClick={() => setIsAppConfigModalOpen(true)}
                                                            >
                                                                {item.value}
                                                            </Button>
                                                        ) : item.type === 'tag' ? (
                                                            <Tag color={item.color} style={{ marginRight: 0, fontSize: 11 }}>{item.value}</Tag>
                                                        ) : (
                                                            <Text strong={item.strong}>{item.value}</Text>
                                                        )}
                                                    </div>
                                                </List.Item>
                                            )}
                                        />
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={24}>
                    <Card title="固件版本历史" extra={null}>
                        <Table 
                            columns={columns} 
                            dataSource={firmwareData} 
                            pagination={false} 
                            size="small"
                        />
                    </Card>
                </Col>
            </Row>

            {/* 固件历史版本抽屉 */}
            <Drawer
                title={`固件历史版本 - ${selectedFirmware?.name || ''}`}
                placement="right"
                onClose={() => setIsFirmwareDrawerOpen(false)}
                open={isFirmwareDrawerOpen}
                width={1200}
            >
                <ConfigProvider locale={zhCN}>
                    <Table 
                        columns={firmwareHistoryColumns} 
                        dataSource={firmwareHistoryData} 
                        pagination={{
                            total: 50,
                            pageSize: 10,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `共 ${total} 条`
                        }}
                        size="small"
                    />
                </ConfigProvider>
            </Drawer>

            {/* 默认生效配置详情弹窗 */}
            <Modal
                title="默认生效配置详情"
                open={isAppConfigModalOpen}
                onCancel={() => setIsAppConfigModalOpen(false)}
                footer={[
                    <Button key="close" type="primary" onClick={() => setIsAppConfigModalOpen(false)}>
                        关 闭
                    </Button>
                ]}
                width={600}
                centered
            >
                <Table
                    dataSource={appDefaultConfig}
                    columns={[
                        { title: '配置名称', dataIndex: 'label', key: 'label', width: '35%', className: 'bg-gray-light' },
                        { title: '配置内容', dataIndex: 'value', key: 'value' }
                    ]}
                    pagination={false}
                    size="middle"
                    bordered
                    showHeader={false}
                    rowKey="label"
                    style={{ marginTop: 8 }}
                />
            </Modal>

            {/* 套餐配置抽屉 */}
            <Drawer
                title={`查看/选择套餐 - ${currentPackageAlgo?.name || ''}`}
                placement="right"
                onClose={() => setIsPackageDrawerOpen(false)}
                open={isPackageDrawerOpen}
                width={600}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Button onClick={() => setIsPackageDrawerOpen(false)} style={{ marginRight: 8 }}>
                            取消
                        </Button>
                        <Button type="primary" onClick={() => {
                            const selectedPkg = packageData.find(p => p.key === selectedPackageKey);
                            if (!selectedPkg) {
                                message.warning('请选择一个套餐');
                                return;
                            }
                            if (drawerSource === 'algorithm') {
                                const newData = [...algorithmData];
                                const idx = newData.findIndex(item => item.id === currentPackageAlgo.id);
                                if (idx > -1) {
                                    newData[idx].packageName = selectedPkg.name;
                                    newData[idx].packageKey = selectedPkg.key;
                                    setAlgorithmData(newData);
                                }
                            } else {
                                const newData = [...platformServices];
                                const idx = newData.findIndex(item => item.key === currentPackageAlgo.key);
                                if (idx > -1) {
                                    newData[idx].packageName = selectedPkg.name;
                                    setPlatformServices(newData);
                                }
                            }
                            setIsPackageDrawerOpen(false);
                            message.success('选择成功');
                        }}>
                            确定
                        </Button>
                    </div>
                }
            >
                <div style={{ marginBottom: 16 }}>
                    <Row gutter={8}>
                        <Col span={10}>
                            <Input 
                                placeholder="输入套餐名称搜索" 
                                value={packageSearchValues.name}
                                onChange={e => setPackageSearchValues({...packageSearchValues, name: e.target.value})}
                            />
                        </Col>
                        <Col span={10}>
                            <Input 
                                placeholder="输入套餐ID搜索" 
                                value={packageSearchValues.id}
                                onChange={e => setPackageSearchValues({...packageSearchValues, id: e.target.value})}
                            />
                        </Col>
                        <Col span={4}>
                            <Button icon={<ReloadOutlined />} onClick={() => setPackageSearchValues({ name: '', id: '' })}>重置</Button>
                        </Col>
                    </Row>
                </div>
                <Table
                    size="small"
                    rowKey="key"
                    dataSource={filteredPackages}
                    rowSelection={{
                        type: 'radio',
                        selectedRowKeys: selectedPackageKey ? [selectedPackageKey] : [],
                        onChange: (keys) => setSelectedPackageKey(keys[0]),
                    }}
                    columns={[
                        { title: '套餐ID', dataIndex: 'id', key: 'id' },
                        { title: '套餐名称', dataIndex: 'name', key: 'name' },
                        { title: '描述', dataIndex: 'desc', key: 'desc', ellipsis: true },
                    ]}
                    pagination={{ pageSize: 8 }}
                />
            </Drawer>

            {/* 物模型配置查看/修改 Drawer */}
            <Drawer
                title="物模型配置"
                onClose={() => setModelDrawerVisible(false)}
                open={modelDrawerVisible}
                width={1000}
                destroyOnClose
                extra={
                    <Space>
                        <Button onClick={() => setModelDrawerVisible(false)}>取消</Button>
                        <Button type="primary" onClick={() => { message.success('物模型配置已保存'); setModelDrawerVisible(false); }}>保存</Button>
                    </Space>
                }
            >
                <Tabs 
                    activeKey={activeTab} 
                    onChange={(key) => {
                        setActiveTab(key);
                        const firstMenu = thingModelData[tabLabelMap[key]]?.['配置选项']?.[0];
                        if (firstMenu) setActiveMenu(firstMenu);
                    }}
                    items={Object.entries(tabLabelMap).map(([key, label]) => ({
                        key,
                        label: (
                            <Space>
                                {key === '1' && <AppstoreOutlined />}
                                {key === '2' && <VideoCameraOutlined />}
                                {key === '3' && <AudioOutlined />}
                                {key === '4' && <EyeOutlined />}
                                {key === '5' && <BellOutlined />}
                                {label}
                            </Space>
                        )
                    }))}
                    style={{ marginBottom: 16 }}
                />

                <div style={{ padding: '0 24px' }}>
                    {activeData.globalConfig && (
                        <Card size="small" style={{ marginBottom: 16, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center' }}>
                                <Space><SettingOutlined style={{ color: '#1890ff' }} /><Text strong>全局配置</Text></Space>
                            </div>
                            <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center' }}>
                                <Text style={{ width: 140, color: '#595959' }}>{activeData.globalConfig.label} :</Text>
                                <Radio.Group value={activeData.globalConfig.value} onChange={e => updateGlobalConfig(e.target.value)}>
                                    {activeData.globalConfig.options.map(opt => (
                                        <Radio key={opt} value={opt}>{opt}</Radio>
                                    ))}
                                </Radio.Group>
                            </div>
                        </Card>
                    )}

                    {(activeData.instanceName || (activeData.config && activeData.config.length > 0)) && (
                        <Card size="small" bodyStyle={{ padding: 0 }} style={{ borderRadius: 0, border: '1px solid #f0f0f0', marginBottom: 24 }}>
                            {activeData.cardTitle && (
                                <div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center' }}>
                                    <Space><CameraOutlined style={{ color: '#1890ff' }} /><Text strong>{activeData.cardTitle}</Text></Space>
                                </div>
                            )}

                            {activeData.instanceName && (
                                <div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center' }}>
                                    <Space size={12}>
                                        <div style={{ padding: '4px 12px', border: '1px solid #d9d9d9', borderRadius: 4, backgroundColor: '#f5f5f5' }}>
                                            <Text strong>{activeData.instanceName}</Text>
                                        </div>
                                        {activeData.instanceLabel && (
                                            <Button size="small" type="primary" ghost>
                                                {activeData.instanceLabel} <DownOutlined style={{ fontSize: 10 }} />
                                            </Button>
                                        )}
                                    </Space>
                                </div>
                            )}

                            <Row gutter={0}>
                                {(thingModelData[tabLabelMap[activeTab]]?.['配置选项'] || []).length > 0 && (
                                    <Col span={4}>
                                        <div style={{ padding: '12px 0', borderRight: '1px solid #f0f0f0', height: '100%', minHeight: 400, backgroundColor: '#fafafa' }}>
                                            {thingModelData[tabLabelMap[activeTab]]['配置选项'].map(menu => (
                                                <div 
                                                    key={menu}
                                                    onClick={() => setActiveMenu(menu)}
                                                    style={{ 
                                                        padding: '10px 20px', 
                                                        cursor: 'pointer',
                                                        backgroundColor: activeMenu === menu ? '#fff' : 'transparent',
                                                        color: activeMenu === menu ? '#1890ff' : '#595959',
                                                        fontSize: 13,
                                                        fontWeight: activeMenu === menu ? 600 : 400,
                                                        borderRight: activeMenu === menu ? '3px solid #1890ff' : 'none',
                                                        marginBottom: 4,
                                                        transition: 'all 0.3s'
                                                    }}
                                                >
                                                    {menu}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                )}
                                <Col span={(thingModelData[tabLabelMap[activeTab]]?.['配置选项'] || []).length > 0 ? 20 : 24}>
                                    <div style={{ padding: (activeData.multiTarget && activeData.multiTarget.length > 0) ? '24px' : '32px 48px' }}>
                                        {activeData.multiTarget && activeData.multiTarget.length > 0 ? (
                                            <>
                                                {activeData.multiTarget.map((lens, idx) => (
                                                    <Card 
                                                        key={lens.id} 
                                                        size="small" 
                                                        style={{ marginBottom: 16, borderRadius: 8, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                                                        title={<Text strong>{lens.label}</Text>}
                                                    >
                                                        <div style={{ padding: '8px 20px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>镜头类型</Text>
                                                                <Select value={lens.type} onChange={v => updateMultiTarget(idx, 'type', v)} style={{ flex: 1 }}>
                                                                    <Option value="普通镜头">普通镜头</Option>
                                                                </Select>
                                                            </div>
                                                            <Row gutter={48}>
                                                                <Col span={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>最大焦距</Text>
                                                                        <InputNumber value={lens.maxFocal} onChange={v => updateMultiTarget(idx, 'maxFocal', v)} style={{ flex: 1 }} />
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Text style={{ width: 100, textAlign: 'right', marginRight: 24, color: '#595959' }}>最小焦距</Text>
                                                                        <InputNumber value={lens.minFocal} onChange={v => updateMultiTarget(idx, 'minFocal', v)} style={{ flex: 1 }} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card>
                                                ))}
                                            </>
                                        ) : activeData.config.length > 0 ? (
                                            activeData.config.map((item, index) => (
                                                <div key={index} style={{ marginBottom: index === activeData.config.length - 1 ? 0 : 24, display: 'flex', alignItems: 'center' }}>
                                                    <Text style={{ width: 140, textAlign: 'right', marginRight: 24, color: '#595959' }}>{item.label}</Text>
                                                    <div style={{ flex: 1 }}>
                                                        {item.type === 'checkbox' ? (
                                                            <Checkbox.Group value={item.value} onChange={v => updateConfigItem(index, v)} style={{ width: '100%' }}>
                                                                <Space size={32} wrap>
                                                                    {item.options.map(opt => (
                                                                        <Checkbox key={opt} value={opt}>{opt}</Checkbox>
                                                                    ))}
                                                                </Space>
                                                            </Checkbox.Group>
                                                        ) : item.type === 'radio' ? (
                                                            <Radio.Group value={item.value} onChange={e => updateConfigItem(index, e.target.value)}>
                                                                <Space size={32} wrap>
                                                                    {item.options.map(opt => (
                                                                        <Radio key={opt} value={opt}>{opt}</Radio>
                                                                    ))}
                                                                </Space>
                                                            </Radio.Group>
                                                        ) : item.type === 'switch' ? (
                                                            <Switch checked={item.value} onChange={v => updateConfigItem(index, v)} size="small" />
                                                        ) : item.type === 'input-number' ? (
                                                            <InputNumber value={item.value} onChange={v => updateConfigItem(index, v)} size="small" style={{ width: 120 }} />
                                                        ) : item.type === 'select' ? (
                                                            <Select value={item.value} onChange={v => updateConfigItem(index, v)} size="small" style={{ width: 160 }}>
                                                                {item.options.map(opt => (
                                                                    <Select.Option key={opt} value={opt}>{opt}</Select.Option>
                                                                ))}
                                                            </Select>
                                                        ) : item.type === 'title' ? (
                                                            <div style={{ marginBottom: 12, paddingBottom: 8, borderBottom: '1px dashed #f0f0f0' }}>
                                                                <Text strong style={{ fontSize: 14 }}>{item.label}</Text>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ padding: '80px 0', textAlign: 'center' }}>
                                                <Text type="secondary">暂无配置项</Text>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    )}
                </div>

                <div style={{ padding: '0 24px 24px' }}>
                    {!activeData.hideTables && (
                        <Card size="small" style={{ marginBottom: 24, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '4px 12px 12px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <Space>
                                        <Text strong style={{ fontSize: 14 }}>标准能力</Text>
                                        <QuestionCircleOutlined style={{ color: '#8c8c8c', fontSize: 14 }} />
                                    </Space>
                                </div>
                                <Table 
                                    size="small"
                                    pagination={false}
                                    columns={[
                                        { title: '类型', dataIndex: 'type', key: 'type', width: 100 },
                                        { title: '能力名称', dataIndex: 'name', key: 'name' },
                                        { title: '能力标识', dataIndex: 'identifier', key: 'identifier' },
                                        { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                        { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                        { title: '描述', dataIndex: 'desc', key: 'desc' },
                                        { title: '所属模块', dataIndex: 'module', key: 'module' },
                                        { title: '操作', key: 'action', render: () => <Text type="secondary">-</Text> }
                                    ]}
                                    dataSource={activeData.standard || []}
                                    locale={{ emptyText: '暂无数据' }}
                                />
                            </div>
                        </Card>
                    )}

                    {!activeData.hideTables && (
                        <Card size="small" style={{ marginBottom: 24, borderRadius: 0, border: '1px solid #f0f0f0' }}>
                            <div style={{ padding: '4px 12px 12px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <Space>
                                        <Text strong style={{ fontSize: 14 }}>自定义能力</Text>
                                        <QuestionCircleOutlined style={{ color: '#8c8c8c', fontSize: 14 }} />
                                    </Space>
                                </div>
                                <Table 
                                    size="small"
                                    pagination={false}
                                    columns={[
                                        { title: '类型', dataIndex: 'type', key: 'type', width: 100 },
                                        { title: '能力名称', dataIndex: 'name', key: 'name' },
                                        { title: '能力标识', dataIndex: 'identifier', key: 'identifier' },
                                        { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                        { title: '数据定义', dataIndex: 'dataDef', key: 'dataDef' },
                                        { title: '描述', dataIndex: 'desc', key: 'desc' },
                                        { title: '所属模块', dataIndex: 'module', key: 'module' },
                                        { title: '操作', key: 'action', render: () => <Text type="secondary">-</Text> }
                                    ]}
                                    dataSource={activeData.custom || []}
                                    locale={{ emptyText: '暂无数据' }}
                                />
                            </div>
                        </Card>
                    )}
                </div>
            </Drawer>

            {/* 设备使用区域设置 */}
            <Modal title="设备使用区域设置" open={regionModalVisible}
                onOk={() => { const v = regionForm.getFieldsValue(); setRegionMode(v.regionMode); setSelectedCountries(v.selectedCountries || []); setRegionModalVisible(false); message.success('设备使用区域已更新'); }}
                onCancel={() => setRegionModalVisible(false)} okText="保存" cancelText="取消" destroyOnClose width={520}
            >
                <Form form={regionForm} layout="vertical" style={{ marginTop: 16 }}>
                    <Form.Item label="限制模式" name="regionMode">
                        <Radio.Group>
                            <Radio value="none">不限制</Radio>
                            <Radio value="whitelist">白名单（仅允许）</Radio>
                            <Radio value="blacklist">黑名单（禁止使用）</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate={(p, c) => p.regionMode !== c.regionMode}>
                        {({ getFieldValue }) => getFieldValue('regionMode') !== 'none' ? (
                            <Form.Item label={getFieldValue('regionMode') === 'whitelist' ? '允许使用的国家/地区' : '禁止使用的国家/地区'} name="selectedCountries">
                                <Select mode="multiple" placeholder="请选择国家/地区" showSearch optionFilterProp="label" style={{ width: '100%' }}
                                    maxTagCount={5} maxTagPlaceholder={(omitted) => `+${omitted.length}个`}
                                    options={[
                                        { label: '亚洲', options: [{ value: 'CN', label: '中国' }, { value: 'JP', label: '日本' }, { value: 'KR', label: '韩国' }, { value: 'IN', label: '印度' }, { value: 'SG', label: '新加坡' }, { value: 'TH', label: '泰国' }, { value: 'VN', label: '越南' }, { value: 'MY', label: '马来西亚' }, { value: 'PH', label: '菲律宾' }, { value: 'ID', label: '印度尼西亚' }, { value: 'AE', label: '阿联酋' }, { value: 'SA', label: '沙特阿拉伯' }, { value: 'TR', label: '土耳其' }] },
                                        { label: '欧洲', options: [{ value: 'GB', label: '英国' }, { value: 'DE', label: '德国' }, { value: 'FR', label: '法国' }, { value: 'IT', label: '意大利' }, { value: 'ES', label: '西班牙' }, { value: 'NL', label: '荷兰' }, { value: 'RU', label: '俄罗斯' }] },
                                        { label: '北美洲', options: [{ value: 'US', label: '美国' }, { value: 'CA', label: '加拿大' }, { value: 'MX', label: '墨西哥' }] },
                                        { label: '南美洲', options: [{ value: 'BR', label: '巴西' }, { value: 'AR', label: '阿根廷' }] },
                                        { label: '大洋洲', options: [{ value: 'AU', label: '澳大利亚' }, { value: 'NZ', label: '新西兰' }] },
                                        { label: '非洲', options: [{ value: 'ZA', label: '南非' }, { value: 'EG', label: '埃及' }] },
                                    ]}
                                />
                            </Form.Item>
                        ) : null}
                    </Form.Item>
                </Form>
            </Modal>
            {/* 平台服务算法配置抽屉 */}
            <Drawer title="算法配置" width={500} open={platAlgoDrawer} onClose={() => setPlatAlgoDrawer(false)} destroyOnClose>
                {platAlgoConfig.id === '1010' && (
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16 }}>云存录像 — 码流配置</div>
                        <Radio.Group value={platAlgoConfig.streamType} onChange={e => setPlatAlgoConfig({ ...platAlgoConfig, streamType: e.target.value })}>
                            <Radio value="main">主码流</Radio><Radio value="sub">次码流</Radio>
                        </Radio.Group>
                    </div>
                )}
                {platAlgoConfig.id === '1063' && (
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16 }}>语音助手 — 工作模式</div>
                        <Radio.Group value={platAlgoConfig.workMode} onChange={e => setPlatAlgoConfig({ ...platAlgoConfig, workMode: e.target.value })} style={{ marginBottom: 24 }}>
                            <Radio value="local">设备(本地)</Radio><Radio value="cloud">云端平台</Radio>
                        </Radio.Group>
                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16 }}>码流配置</div>
                        <Radio.Group value={platAlgoConfig.streamType} onChange={e => setPlatAlgoConfig({ ...platAlgoConfig, streamType: e.target.value })}>
                            <Radio value="main">主码流</Radio><Radio value="sub">次码流</Radio>
                        </Radio.Group>
                    </div>
                )}
            </Drawer>
        </div>
    );
};

export default ProductManage;
